// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__20DGB","rightAdornment":"Header_rightAdornment__35EcZ"};